<div class="simple-table-container">
  @if (withSearch()) {
    <div class="search-container">
      <coin-v2-text-input
        icon="search"
        matFormFieldClass="shadow"
        [placeholder]="'search' | translate"
        (input)="onSearchChange($event.target['value'])" />
    </div>
  }

  <div class="simple-table">
    <div
      #tableHeader
      class="header-row template-columns"
      [style.grid-template-columns]="templateColumns"
      [style.padding-right.px]="contentScrollBarWidth()">
      @for (item of headerObjects; track item; let i = $index) {
        <div
          class="header-column"
          style="flex-wrap: wrap"
          [class.with-controls]="item.key"
          [class.overlay]="item.overlay"
          [class.overlay--start]="item.overlayStart"
          [class.overlay--end]="item.overlayEnd"
          [class.overlay--contrast]="item.overlayContrast"
          [class.centered]="item.centered"
          [class.inactive]="isItemInactive(item.group)"
          [class.hidden]="isItemInactive(item.group) && !isGroupStart(item, i)">
          @if (item.group) {
            <div
              class="group"
              [class.start]="isGroupStart(item, i)"
              [class.inactive]="isItemInactive(item.group)"
              [class.end]="isGroupEnd(item, i)"
              [class.end-radius]="isGroupEnd(item, i) || isItemInactive(item.group)"
              (click)="toggleInactive(item.group)">
              @if (isGroupStart(item, i)) {
                <div class="group-title">
                  <p class="bold">{{ item.group }}</p>
                </div>
              }
              @if (isGroupEnd(item, i)) {
                <mat-icon>visibility_on</mat-icon>
              }
              @if (isGroupStart(item, i) && isItemInactive(item.group)) {
                <mat-icon>visibility_off</mat-icon>
              }
            </div>
          }

          <div class="header">
            @if (item.key && !item.hideFilter) {
              <div class="filter-controls">
                @if (filterActive(item.key)) {
                  <mat-icon
                    class="clear-filter"
                    (click)="clearFilterByKey(item.key)">
                    clear
                  </mat-icon>
                }
                @if (item.filterType) {
                  <span
                    class="expand-mat-icon st-filter"
                    [class.st-filter--active]="filterActive(item.key)"
                    [class.no-sorting]="item.hideSorting"
                    [matTooltip]="item.filterTooltip | translate"
                    (click)="showFilterOptions(item)">
                    <img
                      aria-label="filter"
                      style="width: 18px; height: 18px"
                      src="/assets/svgs/filter.svg" />
                  </span>
                }
                @if (!item.hideSorting) {
                  <div class="sort-controls">
                    <div
                      class="sort-button"
                      [ngClass]="{
                        active: sortedItemsBy['type'] === item.key && sortedItemsBy['direction'] === 'desc'
                      }"
                      (click)="sortBy(item, 'desc')">
                      <mat-icon class="expand-mat-icon icon-less">expand_less</mat-icon>
                    </div>
                    <div
                      class="sort-button"
                      [ngClass]="{ active: sortedItemsBy['type'] === item.key && sortedItemsBy['direction'] === 'asc' }"
                      (click)="sortBy(item, 'asc')">
                      <mat-icon class="expand-mat-icon icon-more">expand_more</mat-icon>
                    </div>
                  </div>
                }
              </div>
            }

            @if (item.hide) {
              <div class="spacer"></div>
            }

            @if (!item.hide) {
              <p
                class="header-title"
                (click)="showFilterOptions(item)">
                {{ item.title | translate }}
              </p>
            }
            @if (item.checkAll) {
              <coin-v2-checkbox
                class="check-all"
                matTooltipPosition="right"
                matTooltip="Select all visible items"
                [ngModel]="allVisibleSelected() || forceCheckAll"
                [disabled]="disableCheckAll()"
                (ngModelChange)="checkAllToggle($event)"></coin-v2-checkbox>
            }

            @if (showFilter === item.key) {
              <div
                class="sub-header"
                animate.enter="expand"
                animate.leave="shrink">
                @if (item.filterType === 'date' && !serverside()) {
                  <mat-form-field
                    class="simple-table-date"
                    [floatLabel]="$any('never')">
                    <input
                      aria-label="date input"
                      matInput
                      [matDatepicker]="pickerCreatedFrom"
                      [placeholder]="'general.from' | translate"
                      [(ngModel)]="filterVariables[item.key + '---' + 'From']"
                      (dateChange)="applyFilter()"
                      (focus)="pickerCreatedFrom.open()" />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="pickerCreatedFrom"></mat-datepicker-toggle>
                    <mat-datepicker #pickerCreatedFrom></mat-datepicker>
                  </mat-form-field>
                }

                @if (item.filterType === 'date' && !serverside()) {
                  <mat-form-field
                    class="simple-table-date date-picker"
                    [floatLabel]="$any('never')">
                    <input
                      aria-label="date input"
                      matInput
                      [matDatepicker]="pickerCreatedTo"
                      [placeholder]="'general.to' | translate"
                      [(ngModel)]="filterVariables[item.key + '---' + 'To']"
                      (dateChange)="applyFilter()"
                      (focus)="pickerCreatedTo.open()" />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="pickerCreatedTo"></mat-datepicker-toggle>
                    <mat-datepicker #pickerCreatedTo></mat-datepicker>
                  </mat-form-field>
                }

                @if (item.filterType === 'datePeriod' && serverside()) {
                  <mat-form-field
                    class="simple-table-date"
                    [floatLabel]="$any('never')">
                    <input
                      aria-label="date input"
                      matInput
                      [matDatepicker]="pickerCreatedFrom"
                      [placeholder]="'general.from' | translate"
                      [(ngModel)]="filterVariables[item.key + '---' + 'From']"
                      (dateChange)="applyFilter()"
                      (focus)="pickerCreatedFrom.open()" />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="pickerCreatedFrom"></mat-datepicker-toggle>
                    <mat-datepicker #pickerCreatedFrom></mat-datepicker>
                  </mat-form-field>
                }

                @if (item.filterType === 'datePeriod' && serverside()) {
                  <mat-form-field
                    class="simple-table-date date-picker"
                    [floatLabel]="$any('never')">
                    <input
                      aria-label="date input"
                      matInput
                      [matDatepicker]="pickerCreatedTo"
                      [placeholder]="'general.to' | translate"
                      [(ngModel)]="filterVariables[item.key + '---' + 'To']"
                      (dateChange)="applyFilter()"
                      (focus)="pickerCreatedTo.open()" />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="pickerCreatedTo"></mat-datepicker-toggle>
                    <mat-datepicker #pickerCreatedTo></mat-datepicker>
                  </mat-form-field>
                }

                @if (item.filterType === 'date' && serverside() && !hasV2DatePicker()) {
                  <mat-form-field
                    class="simple-table-date"
                    [floatLabel]="$any('never')">
                    <input
                      aria-label="date input"
                      matInput
                      [matDatepicker]="generalDatePicker"
                      [(ngModel)]="filterVariables[item.key]"
                      (dateChange)="applyFilter()"
                      (focus)="generalDatePicker.open()" />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="generalDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #generalDatePicker></mat-datepicker>
                  </mat-form-field>
                }

                @if (item.filterType === 'date' && serverside() && hasV2DatePicker()) {
                  <coin-v2-date-input
                    aria-label="date input"
                    class="simple-table-date"
                    [(ngModel)]="filterVariables[item.key]"
                    (ngModelChange)="applyFilter()"></coin-v2-date-input>
                }

                @if ((item.filterType === 'dropdown' || item.filterType === 'customDropdown') && item?.async) {
                  <coin-v2-dropdown
                    #search="dropdownSearch"
                    style="max-width: 100%"
                    [dataSource]="item.fieldValuesKey ?? item.key | pure: createPatchedLazyLoadFn"
                    [multiple]="true"
                    [(ngModel)]="filterVariables[item.key]"
                    (ngModelChange)="applyFilter()">
                    @for (value of search.results() | sortAlphabetically; track value) {
                      <ng-template [coinValue]="value">{{ dropdownDisplayFn()?.(value) ?? value }}</ng-template>
                    }
                  </coin-v2-dropdown>
                }
                @if (item.filterType === 'dropdown' && !item?.async) {
                  <coin-v2-dropdown
                    #search="dropdownSearch"
                    style="max-width: 100%"
                    [dataSource]="item | pure: getDropdownVals : originalData"
                    [multiple]="true"
                    [(ngModel)]="filterVariables[item.key]"
                    (ngModelChange)="applyFilter()">
                    @for (value of search.results() | sortAlphabetically; track value) {
                      <ng-template [coinValue]="value">{{ dropdownDisplayFn()?.(value) ?? value }}</ng-template>
                    }
                  </coin-v2-dropdown>
                }

                @if (item.filterType === 'input') {
                  <coin-v2-text-input
                    [placeholder]="'general.please-enter' | translate"
                    [(ngModel)]="filterVariables[item.key]"
                    (input)="applyFilter()" />
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div
      #tableContentWrapper
      cdkScrollable
      class="simple-table-content">
      <div class="content-container simple-table no-space">
        @if (dragAndDrop()) {
          <div
            #tableScrollContentWrapper
            class="drop-list"
            cdkScrollable
            cdkDropList
            [cdkDropListAutoScrollDisabled]="false"
            [cdkDropListSortPredicate]="sortPredicate.bind(this)"
            (cdkDropListDropped)="onDrop($event)">
            @for (item of data; track trackByItemFn(i, item); let i = $index) {
              <div
                #row
                cdkDrag
                class="content-row template-columns"
                animate.enter="expand"
                animate.leave="shrink"
                [adminTableGroup]="inactiveColumns$"
                [cdkDragBoundary]="tableScrollContentWrapper"
                [attr.id]="item?.id"
                [style.grid-template-columns]="!item?.isSeparator ? templateColumns : 'unset'"
                [cdkDragDisabled]="item.isDragDisabled"
                [class.drag-disabled]="item.isDragDisabled"
                [cdkDragData]="item"
                [class.separator-container]="item?.isSeparator">
                <ng-template
                  [ngTemplateOutlet]="columnsRef"
                  [ngTemplateOutletContext]="{ $implicit: item, index: i }"></ng-template>
              </div>
            }
          </div>
        } @else {
          @for (item of data; track trackByItemFn(i, item); let i = $index) {
            <div
              #row
              class="content-row template-columns"
              [adminTableGroup]="inactiveColumns$"
              [attr.id]="item?.id"
              [style.grid-template-columns]="!item?.isSeparator ? templateColumns : 'unset'"
              [class.separator-container]="item?.isSeparator">
              <ng-template
                [ngTemplateOutlet]="columnsRef"
                [ngTemplateOutletContext]="{ $implicit: item, index: i }"></ng-template>
            </div>
          }
        }
      </div>
    </div>
    @if (dataAvailable && loading()) {
      <div class="loading-no-data-container">
        <v2-turbine [contrast]="true"></v2-turbine>
      </div>
    }
    @if (!dataAvailable) {
      <div class="loading-no-data-container no-data">
        @if (!loading() && !data?.length && noDataRef) {
          <ng-template [ngTemplateOutlet]="noDataRef"></ng-template>
        }
        @if (loading()) {
          <v2-turbine></v2-turbine>
        }
      </div>
    }

    <div class="action-bar">
      @if (buttonsRef) {
        <div class="button-container">
          <ng-template [ngTemplateOutlet]="buttonsRef"></ng-template>
        </div>
      }

      @if (!hidePagination()) {
        <div class="paginator">
          <mat-paginator
            #paginator
            [length]="length"
            [pageSize]="pageSize()"
            [pageSizeOptions]="pageSizeOptions"
            (page)="pageChange($event)"></mat-paginator>
        </div>
      }
    </div>
  </div>
</div>
